// extracted by mini-css-extract-plugin
export default {"DeletionModal":"DeleteModuleModal_DeletionModal__VLhoh"};